import { useState } from 'react';

import {
  Divider,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  MenuItem,
  Tooltip,
} from '@mui/material';
import copy from 'clipboard-copy';
import { CopyIcon } from 'lucide-react';

import { formatPhone } from '@modules/_shared/utils/formatting';
import { useLocale } from '@shared/hooks/locale';

export const usePhoneCopyMenuItems = (
  phoneNumbers: { number: string }[],
): React.ReactNode[] => {
  const { t } = useLocale();
  const [displayTooltip, setDisplayTooltip] = useState(false);

  if (phoneNumbers.length === 0) {
    return [];
  }

  return [
    <Tooltip
      key="phone-numbers-subheader"
      slotProps={{
        popper: {
          disablePortal: true,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -50],
              },
            },
          ],
        },
      }}
      onClose={() => setDisplayTooltip(false)}
      open={displayTooltip}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={t('Copied to clipboard')}
    >
      <ListSubheader>{t('Phone numbers')}</ListSubheader>
    </Tooltip>,
    ...phoneNumbers.map(phone => (
      <MenuItem
        key={phone.number}
        onClick={() => {
          copy(phone.number);
          setDisplayTooltip(true);
          setTimeout(() => setDisplayTooltip(false), 1000);
        }}
      >
        <ListItemIcon>
          <CopyIcon size={18} />
        </ListItemIcon>
        <ListItemText>{formatPhone(phone.number)}</ListItemText>
      </MenuItem>
    )),
    <Divider key="phone-numbers-divider" />,
  ];
};
